import * as React from 'react';
import { makeStyles } from '@mui/styles';
import { zhTW } from 'date-fns/locale';
import { ICON_CALENDAR } from '../_style';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { RiCalendarTodoLine } from 'react-icons/ri';
import { Box, TextField, Hidden, InputAdornment } from '@mui/material';


const useStyles = makeStyles((theme) => ({
  PaperProps: {
    marginTop: 10,
    borderRadius: `${theme.borderRadius.large}px !important`,
    boxShadow: `${theme.palette.shadow.main} !important`,
    '& .PrivatePickersFadeTransitionGroup-root.MuiCalendarPicker-viewTransitionContainer > div > div:nth-of-type(2)': {
      minHeight: 250,
    },
  },
  OpenPickerButtonProps: {
    width: '2.2rem',
    color: theme.palette.icon.main,
    transition: '.3s',
    '&:hover': {
      color: theme.palette.primary.main,
    },
    [theme.breakpoints.down('sm')]: {
      position: 'absolute',
      top: '50%',
      right: 2,
    },
  },
  error: {
    paddingLeft: 15,
    color: theme.palette.text.error,
    fontSize: 12,
  },
  MobileDatePicker: {
    '& .MuiPaper-root': {
      borderRadius: `${theme.borderRadius.large}px !important`,
      boxShadow: `${theme.palette.shadow.main} !important`,
    },
    '& button': {

    },
  },
}));


/**
 * 日曆 單日期
 * @param {string} dateValue 初值
 * @param {Hooks} setDateValue 設定資料
 * @param {string} label 標籤 有資料顯示標籤，無 不顯示
 * @param {boolean} disabled true-禁用
 * @param {boolean} error 錯誤 true-顯示紅框
 * @param {string} minDate 最小可選日期，無 不限
 * @param {string} maxDate 最大可選日期，無 不限
 */
export function DatePickerCom({dateValue, setDateValue, label, disabled, error, minDate, maxDate}) {

  const classes = useStyles();

  const handleChange = (newValue) => {
    setDateValue(newValue);
  };

  return (
    <Box
      sx={{
        'label': {
          color: (theme) => error ? theme.palette.text.error : theme.palette.text.secondary,
        },
        '& fieldset': {
          border: (theme) => error ? `1px solid ${theme.palette.text.error}` : 'auto',
        },
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={zhTW}>

        <Hidden smDown>
          <DesktopDatePicker
            label={label ? label : null}
            format='yyyy/MM/dd'
            value={dateValue}
            onChange={handleChange}
            disabled={disabled}
            minDate={minDate}
            maxDate={maxDate}
            slots={{ textField: TextField, openPickerIcon: RiCalendarTodoLine }}
            slotProps={{
              textField: { size: 'small', fullWidth: true },
              popper: { className: classes.PaperProps },
              openPickerButton: { className: classes.OpenPickerButtonProps },
            }}
          />
        </Hidden>

        <Hidden smUp>
          <MobileDatePicker
            label={label ? label : null}
            format='yyyy/MM/dd'
            value={dateValue}
            onChange={handleChange}
            disabled={disabled}
            minDate={minDate}
            maxDate={maxDate}
            slots={{
              textField: (params) => (
                <TextField
                  {...params}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment className={classes.OpenPickerButtonProps}>
                        <ICON_CALENDAR size={{ box: 'm', svg: 'm' }} />
                      </InputAdornment>
                    ),
                  }}
                />
              ),
            }}
            slotProps={{
              textField: { size: 'small', fullWidth: true },
              dialog: {
                className: classes.MobileDatePickerDialog,
              },
            }}
          />
        </Hidden>
      </LocalizationProvider>

      {
        error
        ? <Box className={classes.error} mt={1}>日期錯誤</Box>
        : null
      }
    </Box>
  )
}